import React from 'react';

export default function Banner({ children, actions, test }) {
  return (
    <div data-test={test} className="Banner flex bg-neutral-darker rounded-t shadow border-t-4 border-neutral text-secondary p-4 px-6 fixed bottom-0 left-0 right-0 z-50">
      <p className="flex-1 pr-4">
        {children}
      </p>
      <div>
        {actions}
      </div>
    </div>
  );
}
